import React from 'react';
import PropTypes from 'prop-types';
import dumbBem from 'dumb-bem';
import { makeStates } from 'dumb-bem/lib/plugins';
import tx from 'transform-props-with';

import Appear from 'components/common/reactAppear';

import {
  Title,
  Description,
  Block,
  Content,
} from 'components/landing/components';

const dumbMain = dumbBem('main', { plugins: [makeStates] });
const StepInfo = tx([{ element: 'step-info' }, dumbMain])('div');
const StepImageWrp = tx([{ element: 'step-image-wrp' }, dumbMain])('div');
const StepImage = tx([{ element: 'step-image' }, dumbMain])('img');

const Step = ({ step, isMobile }) => {
  return (
    <Block modifier="step">
      <Content>
        <Title modifier="3">{step.preTitle}</Title>
        <Title modifier="step">{step.title}</Title>

        <Appear
          className="main appear-animation"
          isMobile={isMobile}
        >
          <StepInfo modifier={step.modifier || ''}>
            <StepImageWrp>
              <StepImage src={step.icon} alt="" />
            </StepImageWrp>

            <Description modifier={`step ${step.modifier || ''}`}>{step.desc}</Description>
          </StepInfo>
        </Appear>
      </Content>
    </Block>
  );
};

Step.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  step: PropTypes.shape({
    preTitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
  }).isRequired,
};

export default Step;



// WEBPACK FOOTER //
// ./src/components/landing/pages/main/Step.js